import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

const Copyrightlp = () => {
    return (
        <section class="copright_lp">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={10} xl={10} xxl={10} className="text-center m-auto">
                        <p>COPYRIGHT 2024 TEKREVOL ALL RIGHTS RESERVED.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Copyrightlp